module.exports = __webpack_public_path__ + "img/making-money-brick-background.1f110779.svg";